import { render } from "./index.vue?vue&type=template&id=46d96bbc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=46d96bbc&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d96bbc"]])

export default __exports__